import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export const SUPPORTED_LANGS = ["nl", "en", "de", "fr", "es", "it", "da"];

/**
 * LangShell, wrapper that detects the language from the URL prefix and syncs
 * it to the global lang context. Used as the element for /{lang}/* routes.
 *
 * The active language is determined by inspecting the first (or 3rd, when
 * under /p/:slug/) path segment.
 */
export default function LangShell({ children }) {
  const location = useLocation();
  const { lang, setLang } = useApp();

  // Determine lang from URL: /xx/... OR /p/:slug/xx/...
  const parts = location.pathname.split("/").filter(Boolean);
  let urlLang = null;
  if (parts[0] === "p" && parts[1] && SUPPORTED_LANGS.includes(parts[2])) {
    urlLang = parts[2];
  } else if (SUPPORTED_LANGS.includes(parts[0])) {
    urlLang = parts[0];
  }

  useEffect(() => {
    if (urlLang && urlLang !== lang) setLang(urlLang);
  }, [urlLang, lang, setLang]);

  return children;
}

/**
 * Returns the current language URL prefix ("/de", "/es", … or "" for NL default).
 * Use to build links that respect the active language.
 */
export function useLangPrefix() {
  const { lang } = useApp();
  return lang && lang !== "nl" ? `/${lang}` : "";
}
